var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Models == null) {
  InlineVariations.Models = {};
}

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.Trait = require('../views/trait');

InlineVariations.Views.NativeDropdownTrait = require('../views/native_dropdown_trait');

InlineVariations.Models.Trait = Backbone.Model.extend({
  initialize: function(arg, arg1) {
    var id, isTouch, layout;
    id = arg.id, layout = arg.layout;
    isTouch = arg1.isTouch;
    if (layout != null ? layout.isNativeDropdown : void 0) {
      return this.view = new InlineVariations.Views.NativeDropdownTrait({
        model: this,
        el: "#" + id
      });
    } else {
      return this.view = new InlineVariations.Views.Trait({
        model: this,
        el: "#" + id,
        isTouch: isTouch
      });
    }
  },
  setSelectedTraitValueById: function(id) {
    var selectedTraitValue;
    if (id) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        id: id
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  getTraitValueById: function(id) {
    return _.findWhere(this.get('values'), {
      id: id
    });
  },
  setSelectedTraitValueByName: function(name) {
    var selectedTraitValue;
    if (name) {
      selectedTraitValue = _.findWhere(this.get('values'), {
        name: name
      });
    }
    return this.updateTraitValue(selectedTraitValue);
  },
  updateTraitValue: function(selectedTraitValue) {
    if (selectedTraitValue && !selectedTraitValue.isSoldOut && !selectedTraitValue.isPlaceholder) {
      return this.set({
        selectedTraitValueId: selectedTraitValue.id,
        selectedTraitValue: selectedTraitValue.name,
        selectedTraitValueHtml: selectedTraitValue.selectedHtml
      });
    } else {
      return this.set({
        selectedTraitValueId: false,
        selectedTraitValue: false,
        selectedTraitValueHtml: false
      });
    }
  }
});

module.exports = InlineVariations.Models.Trait;

//# sourceMappingURL=data:application/json;base64,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
